import Minus from "@/plugin/Enums/modules/Minus";
import PostTypes from "@/plugin/Enums/modules/PostTypes";

import TableTypes from "@/plugin/Enums/modules/TableTypes";
import BarButton from "@/plugin/Enums/modules/BarButton";
import TableButtons from "@/plugin/Enums/modules/TableButtons";
import DialogButton from "@/plugin/Enums/modules/DialogButton";
import Status from "@/plugin/Enums/modules/Status";
import DialogModel from "@/plugin/Enums/modules/DialogModel";

class Enums {
    constructor() {
        this._v = '1.0'
        this._author = 'yaaynn'
        this._email = 'yaaynn@gmail.com'
    }
    get v() {
        return this._v
    }
    get version() {
        return this._v
    }
    get author () {
        return this._author
    }

    static get(){
        return new Enums()
    }
    get Minus() {
        return Minus
    }
    get PostTypes() {
        return PostTypes
    }

    get Types () {
        return { TableTypes }
    }
    get Buttons () {
        return { BarButton, TableButtons, DialogButton }
    }
    get Status () {
        return { Status }
    }
    get Models () {
        return { DialogModel }
    }
}
export default Enums